import {
  Button,
  Dialog,
  DollarIcon,
  Heading,
  InboxIcon,
  Pane,
  RefreshIcon,
  Select,
  Spinner,
  Strong,
  Switch,
  Text,
  TextInputField,
  toaster,
} from "evergreen-ui";
import React, { Component } from "react";

import { connect } from "react-redux";
import {
  downloadEventBooking,
  getCategoriesList,
  getEventBookingList,
  getEventCategorySummary,
  getEvents,
  updateCategoryStatus,
  updateCategoryTickets,
} from "../../actions";
import { toggleLoaderOff, toggleLoaderOn } from "../../actions/loaderUtils";
import EventBookingsTable from "../../components/EventDashboard/EventBookingsTable";
import EventSummary from "../../components/EventDashboard/EventSummary";

class EventDashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPage: false,
      eventList: [],
      categoryList: [],
      eventName: "All events",
      defaultEventName: "All events",
      defaultEventId: -1,
      defaultCategoryName: "All categories",
      defaultCategoryId: -1,
      eventId: -1,
      active: false,
      categoryId: -1,
      categoryName: "All categories",
      pageNo: 1,
      eventBookingList: null,
      summaryDetails: null,
      isShown: false,
      updatedTicketValue: "",
      errorMsg: "",
      inValidTicketUpdate: false,
      categoryIndex: "",
      nextPage: 0,
      totalPage: 0,
      bookingLoader: false,
      subCategoryList: [],
      subCategory: -1,
      subCategoryName: "All sub categories",
      secondSubCategory: -1,
      secondaryCategoryList: [],
      subCategoryMap: {},
    };
  }

  componentDidMount() {
    toggleLoaderOn(this.props.dispatch);
    getEvents().then((data) => {
      toggleLoaderOff(this.props.dispatch);
      if (data.requestStatus === 1) {
        toggleLoaderOn(this.props.dispatch);
        this.setState({
          showPage: true,
          eventList: data.eventList,
        });
        this.getAllCategories();
        let { defaultEventId, defaultCategoryId, pageNo } = this.state;
        const searchTerm = this.getSubCategorySerachTerm(-1, -1);
        this.getSummary(defaultEventId, defaultCategoryId, -1);
        this.getBooking(defaultEventId, defaultCategoryId, pageNo);
      } else {
        toaster.warning(data?.message);
        this.setState({
          showPage: false,
        });
      }
    });
  }

  getSubCategorySerachTerm(subCategory, secondSubCategory) {
    let searchTerm = "";
    if (subCategory == -1 && secondSubCategory == -1) {
      searchTerm = -1;
    }
    else if (subCategory != -1 && secondSubCategory != -1) {
      searchTerm = `${subCategory},${secondSubCategory}`;
    }
    else{
      searchTerm = subCategory != -1 ? subCategory : secondSubCategory;
    }
    return searchTerm;
  }

  getAllCategories = () => {
    getCategoriesList(-1).then((data) => {
      if (data.requestStatus === 1) {
        this.setState({
          categoryList: data.categoryList,
        });
      } else {
        toaster.warning(data?.message);
      }
    });
  }

  getSubCategoriesFromTags(tags) {
    const subCategoriesMap = {};
    const subCategories = new Set();
    const secondarySubCategories = new Set();
    tags.forEach(tag => {
      const parts = tag.split(',');
      const first = parts[0];
      const second = parts[1];
      if (first && !subCategoriesMap[first]) {
        subCategoriesMap[first] = new Set();
      }
      subCategoriesMap[first].add(second);
      subCategories.add(first);
      if (second) {
        secondarySubCategories.add(second);
      }
    });
    return {
      subCategoriesMap,
      subCategories: Array.from(subCategories),
      secondarySubCategories: Array.from(secondarySubCategories)
    };
  }

  getCategoriesByEventId = (e) => {
    let value = e.target.value;
    let name =
      e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text.toString();

      toggleLoaderOn(this.props.dispatch);
      if (value === -1) {
        this.getAllCategories();
        this.setState({
          eventName: "All events",
          eventId: -1,
        });
      } else {
        getCategoriesList(value).then((data) => {
          if (data.requestStatus === 1) {
            this.setState({
              eventName: name,
              eventId: value,
              categoryList: data.categoryList,
              // subCategoryList: data.subCategoryList,
              // secondaryCategoryList: data.secondSubCategoryList,
              secondSubCategory: "-1",
              subCategory: '-1',
              categoryId: -1,
              categoryName: "Select Category",
              pageNo: 1,
              eventBookingList: null,
              summaryDetails: null,
            });
            if (data.tags && data.tags.length > 0) {
              const { subCategoriesMap, subCategories, secondarySubCategories } = this.getSubCategoriesFromTags(data.tags);
              this.setState({
                subCategoryList: subCategories,
                secondaryCategoryList: secondarySubCategories,
                subCategoryMap: subCategoriesMap,
              });
            } else {
              this.setState({
                subCategoryList: [],
                secondaryCategoryList: [],
              });
            }
            this.getSummary(value, this.state.categoryId, -1);
            this.getBooking(value, this.state.defaultCategoryId, this.state.pageNo, -1);
          } else {
            toaster.warning(data?.message);
          }
          
        });
      }
      toggleLoaderOff(this.props.dispatch);
  };

  getEventBooking = (e) => {
    let { categoryList } = this.state;
    let value = e.target.value;
    let categoryIndex = e.target.selectedIndex;
    let name =
      e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text.toString();
    if (value === "-1") {
      let { eventId, defaultCategoryId, pageNo } = this.state;
      this.getBooking(eventId, defaultCategoryId, pageNo, -1);
      this.setState({
        categoryId: defaultCategoryId,
        categoryName: "Select Category",
        pageNo: 1,
        eventBookingList: null,
        summaryDetails: null,
      });
    } else {
      this.setState({ pageNo: 1 });
      let active = categoryList[categoryIndex - 1].active;
      toggleLoaderOn(this.props.dispatch);
      let { eventId, categoryId, pageNo } = this.state;
      this.getBooking(eventId, value, 1, -1);
    }
  };

  getSummary = (eventId, categoryId, searchTerm) => {
    getEventCategorySummary(eventId, categoryId, searchTerm).then((data) => {
      if (data.requestStatus === 1) {
        this.setState({
          summaryDetails: data?.summaryDetails,
          inValidTicketUpdate: false,
          updatedTicketValue: null,
          errorMsg: "",
          active: false,
        });
      } else {
        toaster.warning(data?.message);
      }
    });
  };

  getBooking = (eventId, value, pageNo, searchTerm) => {
    this.setState({ bookingLoader: true });
    getEventBookingList(eventId, value, pageNo, searchTerm).then((data) => {
      toggleLoaderOff(this.props.dispatch);

      this.setState({
        eventBookingList: data?.bookingDetails,
        nextPage: data.paginationData?.next,
        totalPage: data.paginationData?.total,
        bookingLoader: false,
      });
    });
  };

  handlePageChange = async (newPageNum) => {
    let { eventId, categoryId, pageNo } = this.state;
    this.setState({ pageNo: newPageNum });
    let searchTerm = -1;
    if (categoryId == -1)
      searchTerm = this.getSubCategorySerachTerm(this.state.subCategory, this.state.secondSubCategory)
    this.getBooking(eventId, categoryId, newPageNum, searchTerm);
  };

  handleActiveChange = (e) => {
    let { categoryList, categoryIndex } = this.state;
    let active = e.target.checked;
    let body = {
      categoryId: this.state.categoryId,
      status: active,
    };
    console.log({ categoryList });
    updateCategoryStatus(body).then((data) => {
      if (data.requestStatus === 1) {
        let category = categoryList[categoryIndex - 1];

        let newCategory = { ...category, active };

        let updatedCategoryList = [...categoryList];
        updatedCategoryList[categoryIndex - 1] = newCategory;
        console.log({ updatedCategoryList });
        this.setState({
          active: active,
          categoryList: updatedCategoryList,
        });
        toaster.success(data?.message);
      } else {
        toaster.notify(data?.message);
      }
    });
  };

  updateTickets = () => {
    let body = {
      categoryId: this.state.categoryId,
      tickets: this.state.updatedTicketValue,
    };
    if (this.state.categoryId == -1) {
      toaster.warning("Please select a category");
      return;
    }
    updateCategoryTickets(body).then((data) => {
      if (data.requestStatus === 1) {
        let totalTickets = Number(this.state.updatedTicketValue);

        toaster.success(data?.message);
        this.setState({
          isShown: false,
          updatedTicketValue: null,
          summaryDetails: { ...this.state.summaryDetails, totalTickets },
        });
      } else {
        this.setState({
          inValidTicketUpdate: true,
          errorMsg: data?.message,
        });
      }
    });
  };

  getSubCategoryBookings(e) {
    let value = e.target.value;
    this.setState({ subCategory: value, pageNo: 1 });
    toggleLoaderOn(this.props.dispatch);
    getCategoriesList(this.state.eventId, e.target.value).then((data) => {
      if (data.requestStatus === 1) {
        this.setState({
          categoryList: data.categoryList,
          categoryId: -1,
          categoryName: "Select Category",
          eventBookingList: null,
          summaryDetails: null,
        });
      }
      else {
        toaster.warning(data?.message);
      }
    });
    if (value != -1) {
      this.setState({
        secondaryCategoryList: Array.from(this.state.subCategoryMap[value] || []),
        secondSubCategory: -1,
      })
    } else {
      const allSecondaryCategories = new Set();
      Object.values(this.state.subCategoryMap).forEach(set => {
        set.forEach(cat => {
          allSecondaryCategories.add(cat);
        });
      });
      this.setState({
        secondaryCategoryList: Array.from(allSecondaryCategories),
        secondSubCategory: -1,
      });
    }
    const searchTerm = this.getSubCategorySerachTerm(value, -1);
    this.getSummary(this.state.eventId, this.state.categoryId, searchTerm);
    this.getBooking(this.state.eventId, this.state.categoryId, this.state.pageNo, searchTerm);
  }

  getSecondarySubCategoryBookings(e) {
    let value = e.target.value;
    this.setState({ secondSubCategory: value, pageNo: 1 });
    toggleLoaderOn(this.props.dispatch);
    const { subCategory } = this.state;
    const searchTerm = this.getSubCategorySerachTerm(subCategory, value);
    getCategoriesList(this.state.eventId, searchTerm).then((data) => {
      if (data.requestStatus === 1) {
        this.setState({
          categoryList: data.categoryList,
          categoryId: -1,
          categoryName: "Select Category",
          eventBookingList: null,
          summaryDetails: null,
        });
      }
      else {
        toaster.warning(data?.message);
      }
    });
    this.getSummary(this.state.eventId, this.state.categoryId, searchTerm);
    this.getBooking(this.state.eventId, this.state.categoryId, this.state.pageNo, searchTerm);
  }
  

  handlerCategoryChange = (e) => {
    let { categoryList } = this.state;
    let value = e.target.value;
    let categoryIndex = e.target.selectedIndex;
    let name =
      e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text.toString();
    if (value === "-1") {
      let { eventId, defaultCategoryId, pageNo } = this.state;
      this.setState({
        categoryId: defaultCategoryId,
        categoryName: "Select Category",
        pageNo: 1,
        eventBookingList: null,
        summaryDetails: null,
      });
      this.getSummary(eventId, defaultCategoryId, -1);
      this.getBooking(eventId, defaultCategoryId, pageNo);
    } else {
      let active = categoryList[categoryIndex - 1].active;
      let { eventId } = this.state;
      this.setState({
        categoryId: value,
        categoryName: name,
        categoryIndex: categoryIndex,
        active: active,
        pageNo: 1,
      });
      toggleLoaderOn(this.props.dispatch);
      this.getSummary(eventId, value, -1);
      this.getBooking(eventId, value, 1);
    }
  }

  downloadBookings = () => {
    this.props.dispatch(
      downloadEventBooking(
        this.state.categoryId,
        this.state.eventId,
        this.state.subCategory  
      )
    );
  };

  handleEditTickets = () => {
    this.setState({
      isShown: !this.state.isShown,
    });
  };

  filterEventBookingList = (key, order) => {
    const { eventBookingList } = this.state;
    if (!eventBookingList || eventBookingList.length === 0) return;

    const sortedList = [...eventBookingList].sort((a, b) => {
      let valueA, valueB;

      switch (key) {
        case 'bookingId':
          valueA = a.bookingId;
          valueB = b.bookingId;
          break;
        case 'bookingDate':
        case 'dateBooked':
          valueA = new Date(a.dateBooked);
          valueB = new Date(b.dateBooked);
          break;
        case 'name':
          valueA = a.customerDetails?.customerName?.toLowerCase() || '';
          valueB = b.customerDetails?.customerName?.toLowerCase() || '';
          break;
        default:
          valueA = a[key];
          valueB = b[key];
      }

      if (valueA instanceof Date && valueB instanceof Date) {
        return order === 'asc' ? valueA - valueB : valueB - valueA;
      } else if (typeof valueA === 'string' && typeof valueB === 'string') {
        return order === 'asc' 
          ? valueA.localeCompare(valueB) 
          : valueB.localeCompare(valueA);
      } else {
        if (order === 'asc') {
          return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
        } else {
          return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
        }
      }
    });

    this.setState({ eventBookingList: sortedList });
  };

  render() {
    let {
      eventList,
      categoryList,
      eventBookingList,
      defaultEventName,
      defaultEventId,
      eventId,
      categoryId,
      defaultCategoryName,
      active,
      defaultCategoryId,
      summaryDetails,
      isShown,
      errorMsg,
      inValidTicketUpdate,
      pageNo,
      totalPage,
      bookingLoader,
      showPage,
      subCategoryList,
      secondaryCategoryList,
      subCategory,
      secondSubCategory,
    } = this.state;

    return showPage ? (
      <Pane
        display={"flex"}
        margin={60}
        flexDirection={"column"}
        alignItems={"start"}
        justifyContent={"start"}
      >
        <Pane
          display={"flex"}
          flexDirection={"row"}
          alignItems={"start"}
          justifyContent={"start"}
        >
          <Heading size={900}>Events & Passes</Heading>
        </Pane>
        <Pane
          marginTop={16}
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          width={"100%"}
          justifyContent={"space-between"}
        >
          <Pane
            marginTop={32}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={15}
          >
            <Select
              // label="sport"
              size="400"
              height={40}
              width={300}
              value={eventId}
              // disabled={disabled}
              onChange={(e) => this.getCategoriesByEventId(e)}
            >
              <option value={defaultEventId}>{defaultEventName}</option>
              {eventList.map((event, index) => (
                <option key={index} value={event.id}>
                  {event.name}
                </option>
              ))}
            </Select>
            { subCategoryList.length && eventId != -1 ? <Select
              // label="sub category"
              size="200"
              disabled={subCategoryList.length > 0 ? false : true}
              height={40}
              width={200}
              value={subCategory}
              onChange={(e) => this.getSubCategoryBookings(e)}
              // disabled={disabled}
            >
              <option value={-1}>all sub categories</option>

              {subCategoryList.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
            </Select>: null}
            {
              secondaryCategoryList?.length && eventId != -1 ? <Select
              // label="second sub category"
              size="200"
              disabled={secondaryCategoryList.length > 0 ? false : true}
              height={40}
              width={200}
              value={secondSubCategory}
              onChange={(e) => this.getSecondarySubCategoryBookings(e)}
              >
              <option value={-1}>all second sub categories</option>
              
              {secondaryCategoryList.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
              </Select>: null
            }
            <Select
              // label="sport"
              size="400"
              disabled={categoryList.length > 0 ? false : true}
              height={40}
              width={300}
              value={categoryId}
              onChange={(e) => this.handlerCategoryChange(e)}
              // disabled={disabled}
            >
              <option value={defaultCategoryId}>{defaultCategoryName}</option>

              {categoryList.map((category, index) => (
                <option key={index} value={category.id}>
                  {category.name}
                </option>
              ))}
            </Select>
            {/* {eventBookingList && (
              <RefreshIcon
                cursor={"pointer"}
                onClick={() => {
                  this.getBooking(eventId, categoryId, pageNo);
                  this.getSummary(value,active,categoryIndex,name)
                }}
              />
            )} */}
          </Pane>
          {categoryId.length > 0 && (
            <Pane
              marginTop={32}
              marginLeft={10}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={20}
            >
              <Strong>Active</Strong>{" "}
              <Switch
                onChange={(e) => this.handleActiveChange(e)}
                checked={active}
              />
            </Pane>
          )}
        </Pane>
        {summaryDetails ? (
          <EventSummary
            handleEditTickets={this.handleEditTickets}
            summaryDetails={summaryDetails}
          />
        ) : (
          <Pane
            display="flex"
            alignItems="center"
            flexDirection={"row"}
            justifyContent="center"
            width={"100%"}
            height={400}
          >
            <InboxIcon size={50} color={"lightGray"} />
          </Pane>
        )}
        {eventBookingList && (
          <EventBookingsTable
            handleGetBookingDetails={this.props.handleGetBookingDetails}
            downloadBookings={this.downloadBookings}
            eventBookingList={eventBookingList}
            currentPage={pageNo}
            totalPages={totalPage}
            handlePageChange={this.handlePageChange}
            bookingLoader={bookingLoader}
            dispatch={this.props.dispatch}
            bookingDetails={this.props.bookingDetails}
            filterEventBookingList={this.filterEventBookingList}
          />
        )}
        <Dialog
          isShown={isShown}
          onCancel={() =>
            this.setState({
              errorMsg: "",
              inValidTicketUpdate: false,
              updatedTicketValue: null,
              isShown: false,
            })
          }
          hasFooter={false}
          title="Edit Tickets"
        >
          <Pane
            display="flex"
            flexDirection={"row"}
            alignItems={"start"}
            justifyContent={"space-between"}
            gap={20}
          >
            <TextInputField
              width={250}
              label={"Total Tickets"}
              validationMessage={inValidTicketUpdate && errorMsg}
              value={this.state.updatedTicketValue}
              onChange={(e) =>
                this.setState({
                  updatedTicketValue: e.target.value,
                })
              }
            />
            <TextInputField
              cursor={"pointer"}
              width={250}
              disabled
              value={summaryDetails?.totalSoldTickets}
              label={"Sold Tickets"}
            />
          </Pane>

          <Pane
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="end"
            marginBottom={10}
          >
            <Button
              onClick={() => this.updateTickets()}
              background="#00B562"
              color={"white"}
              appearance="#00B562"
            >
              Done
            </Button>
          </Pane>
        </Dialog>
      </Pane>
    ) : (
      <Pane
        display={"flex"}
        flexDirection={"column"}
        width={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
        height={400}
      >
        {"Events Are Not Available "}
      </Pane>
    );
  }
}

const mapStateToProps = ({ clubActivityData, bookingDetails }) => ({
  clubActivityData,
  bookingDetails,
});

// -----------------------------------------------------------------------
// Export
// -----------------------------------------------------------------------
export default connect(mapStateToProps)(EventDashBoard);
